// src/services/entradaMaterialService.js
// Serviço para operações de entrada de material

import api from "./api";

// Função para buscar todas as entradas de material
export const fetchEntradasMaterial = async (filters = {}, page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams();
    
    // Paginação
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    
    // Adicionar filtros se existirem
    if (filters.dataEntrada) {
      params.append("dataEntrada", filters.dataEntrada);
    }
    if (filters.tipo) {
      params.append("tipo", filters.tipo);
    }
    if (filters.produto) {
      params.append("produto", filters.produto);
    }

    const url = `/entrada-material?${params.toString()}`;
    const response = await api.get(url);
    
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar entradas de material:", error);
    throw error;
  }
};

// Função para buscar entrada por ID
export const fetchEntradaMaterialById = async (id) => {
  try {
    const response = await api.get(`/entrada-material/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar entrada de material:", error);
    throw error;
  }
};

// Função para criar nova entrada
export const createEntradaMaterial = async (dadosEntrada) => {
  try {
    const response = await api.post("/entrada-material", dadosEntrada);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar entrada de material:", error);
    throw error;
  }
};

// Função para atualizar entrada
export const updateEntradaMaterial = async (id, dadosEntrada) => {
  try {
    const response = await api.put(`/entrada-material/${id}`, dadosEntrada);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar entrada de material:", error);
    throw error;
  }
};

// Função para deletar entrada
export const deleteEntradaMaterial = async (id) => {
  try {
    const response = await api.delete(`/entrada-material/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar entrada de material:", error);
    throw error;
  }
};

// Função para buscar produtos (para usar nos selects)
export const fetchProdutos = async () => {
  try {
    const response = await api.get("/produtos");
    // A API retorna { success: true, data: { produtos: [...], pagination: {...} } }
    return response.data.data.produtos || [];
  } catch (error) {
    console.error("Erro ao buscar produtos:", error);
    throw error;
  }
};
